<template>
  <!-- App Header -->
  <SideHeader :to="'/'" />
  <!-- * App Header -->

  <!-- App Capsule -->
  <div id="refresh-container">
    <div class="pt-55">
      <Placeholder v-if="loading" />

      <div v-else style="background-color: white">

        <FixLimited v-if="freeCalls != 'false'" :freeCalls="freeCalls" />

        <div class="section" 
        :class="[
            { 'mt-3 mb-3': index !== 0 },
            { 'mt-0 mb-3': index == 0 },
            { 'pt-45': freeCalls == 'false' && index == 0 }
        ]"
          v-for="(cargo, index) in cargos" :key="index.id">
          <CardView :cargo="cargo" />
        </div>
        <!-- <p class="alert alert-warning text-center" v-if="mode == 0 && loadingOff == 0">
          لطفا منتظر بمانید...
        </p> -->
        <button @click="nextLoadCargo()" class="btn btn-success btn-block btn-lg" v-if="mode == 1 && loadingNext == 0">
          نمایش بار های بیشتر کلیک کنید...
        </button>
        <button class="btn btn-warning btn-lg btn-block" type="button" disabled="" v-if="loadingNext == 1">
          <span class="spinner-border spinner-border-sm me-05" role="status" aria-hidden="true"></span>
          درحال بارگذاری ...
        </button>
      </div>
    </div>
    <!-- * App Header -->



    <a href="#" class="button goTop show">
      <ion-icon name="arrow-up-outline"></ion-icon>
    </a>
  </div>
  <!-- * App Capsule -->

  <!-- App Bottom Menu -->
  <!-- <Footer v-show="isLoggedIn" /> -->

  <!-- * App Bottom Menu -->

  <!-- App Sidebar -->

  <!-- * App Sidebar -->
</template>
<script>
import Placeholder from "@/components/Placeholder.vue";
import CardView from "@/views/cargo/components/CardView.vue";
import router from "@/router";
import axios from "axios";
import Swal from "sweetalert2";
import SideHeader from "@/components/SideHeader.vue";
import PullToRefresh from "pulltorefreshjs";
import FixLimited from "@/components/FixLimited.vue";

export default {
  name: "Master",
  components: {
    CardView,
    Placeholder,
    SideHeader,
    FixLimited
    // Footer
  },
  data() {
    return {
      mode: 0,
      loadingOff: 0,
      freeCalls: 'false',
      cargos: [],
      show: false,
      loading: false,
      loadingNext: 0,
      ptrInstance: null,
      axiosConfig: {
        headers: {
          'Authorization': `Bearer ${window.localStorage.getItem("token")}`,
          'Accept': 'application/json'
        }
      }
    };
  },
  methods: {
    initPullToRefresh() {
      if (this.ptrInstance) {
        this.ptrInstance.destroy();
      }
      this.ptrInstance = PullToRefresh.init({
        mainElement: '#refresh-container',
        onRefresh: () => this.getInitialCargos()
      });
    },
    getInitialCargos() {
      this.loading = true;
      axios.get(`https://core.iran-tarabar.ir/api/driver/getNewLoadForDriver/0`, this.axiosConfig)
        .then((response) => {
          if (this.$route.query.token != undefined) {
            axios.patch(`https://core.iran-tarabar.ir/api/driver/saveMyFireBaseToken`, {
              token: this.$route.query.token
            }, this.axiosConfig);
          }

          localStorage.setItem("tel", response.data.Tel);
          if (response.data.result == 0) {
            Swal.fire({
              position: "center",
              icon: "error",
              title: response.data.message,
              showConfirmButton: true,
              confirmButtonText: "تغییر ناوگان",
              // timer: 2000,
            }).then((result) => {
              if (result.isConfirmed) {
                router.push({ name: 'profile' })
              }
            });
          }
          this.cargos = response.data.loads;
          const savedPosition = localStorage.getItem('scrollPosition');
          if (savedPosition) {
            setTimeout(() => {
              window.scrollTo(0, savedPosition);
            }, 250);
            this.loading = false;
          } else {
            this.loading = false;
          }
          this.freeCalls = response.data.freeCalls;
          // console.log(response.data.freeCalls);
          this.getNextCargo();

          // console.log(this.cargos);
        })
        .catch((error) => {
          if (error.response.status === 401) {
            Swal.fire({
              title: "راننده محترم!",
              text: "شماره ای که با آن وارد برنامه شده اید، توسط دستگاه دیگری مورد استفاده قرار گرفته است!",
              icon: "error",
              confirmButtonColor: "#068b80",
              confirmButtonText: "ورود مجدد!",
            }).then((result) => {
              if (result.isConfirmed) {
                localStorage.clear();
                router.push({ name: 'login' })
              }
            });

          }
        });
    },
    getNextCargo() {
      axios.get(`https://core.iran-tarabar.ir/api/driver/getNewLoadForDriver/${this.cargos[this.cargos.length - 1].id}`, this.axiosConfig)
        .then((res) => {
          if (res.data.transactionCount >= 4) {
            if (window.localStorage.getItem("score") != 1) {
              Swal.fire({
                title: "ثبت امتیاز در بازار!",
                imageUrl: "assets/img/bazar-rate.jpg",
                imageWidth: 300,
                imageHeight: 150,
                imageAlt: "bazar app",
                confirmButtonText: "الان امتیاز میدهم!",
                cancelButtonText: "بعدا",
                showCloseButton: true,
                showCancelButton: true
              }).then((result) => {
                if (result.isConfirmed) {
                  localStorage.setItem("score", 1);
                  window.open("https://cafebazaar.ir/app/com.iran_tarabar.driver");
                } else if (
                  result.dismiss === Swal.DismissReason.cancel
                ) {
                  localStorage.setItem("score", 1);
                  // window.open("https://cafebazaar.ir/app/com.iran_tarabar.driver");
                }
              });
            }

          }
          if (res.data.loads == undefined) {
            this.mode = 2;
          }
          this.cargos.push(...res.data.loads);
          this.mode = 1;
        });
      // console.log(this.cargos[this.cargos.length - 1].id);
    },
    nextLoadCargo() {
      this.loadingNext = 1;
      axios
        .get(`https://core.iran-tarabar.ir/api/driver/getNewLoadForDriver/${this.cargos[this.cargos.length - 1].id}`, this.axiosConfig)
        .then((res) => {
          if (res.data.loads.length == 0) {
            this.mode = 0;
            this.loadingOff = 1;
          }
          this.cargos.push(...res.data.loads);
          this.loadingNext = 0;
        })
        .catch((error) => {
          // handle error
          console.log(error);
          this.loadingNext = 0;
          this.mode = 0;
          console.log(this.loadingNext, this.mode);
        });
    },
    saveScrollPosition() {
      localStorage.setItem('scrollPosition', window.scrollY);
    },
  },
  beforeMount() {
    this.getInitialCargos();
  },
  mounted() {
    this.initPullToRefresh();
    // this.restoreScrollPosition();
    // window.addEventListener('beforeunload', this.saveScrollPosition);

  },
  beforeRouteLeave(to, from, next) {
    this.saveScrollPosition();
    next();
  },
  beforeUnmount() {
    if (this.ptrInstance) {
      this.ptrInstance.destroy();
    }
  }
};
</script>
<style>
.pt-45 {
  padding-top: 2rem !important;
}

#webpack-dev-server-client-overlay {
  display: none;
}
</style>